
import React from "react";
import { SectionTitle } from "@/components/SectionTitle";
import { FAQAccordion } from "@/components/FAQAccordion";

interface FAQ {
  question: string;
  answer: string;
}

interface ServiceFAQSectionProps {
  title: string;
  subtitle: string;
  faqs: FAQ[];
}

export const ServiceFAQSection: React.FC<ServiceFAQSectionProps> = ({
  title,
  subtitle,
  faqs,
}) => {
  return (
    <section className="py-16 bg-dental-offwhite">
      <div className="container-custom">
        <SectionTitle
          title={title}
          subtitle={subtitle}
        />

        <div className="mt-12 max-w-3xl mx-auto">
          <FAQAccordion faqs={faqs} />
        </div>
      </div>
    </section>
  );
};
